import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=4c554ed0&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=4c554ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c554ed0",
  null
  
)

export default component.exports